define([], function() {
    return {
        search: 'search',
        poi: 'poiSearch',
        category: 'categorySearch',
        geometry: 'geometrySearch',
        nearby: 'nearbySearch',
        lowBandwidth: 's',
        searchAlongRoute: 'searchAlongRoute'
    };
});



// WEBPACK FOOTER //
// ./common/searchTypes.js